import request from "../request"
import qs from "qs";


export function getGroundResourcesDataTableData(params) {
  return request.get({
    url: "/ground_resource/page",
    params: params
  })
}
export function getGroundResourcesTypeTableData(params) {
  return request.get({
    url: "/ground_resource_type/page",
    params: params
  })
}

export function getFacilityTypeTableData(params) {
  return request.get({
    url: "/facility_type/page",
    params: params
  })
}
export function getFacilityDataTableData(params) {
  return request.get({
    url: "/facility/page",
    params: params
  })
}
export function getAircraftTableData(params) {
  return request.get({
    url: "/fly-car/page",
    params: params
  })
}
export function getAircraftListData(params) {
  return request.get({
    url: "/fly-car/list",
    params: params
  })
}
export function getAircraftDataById(params) {
  return request.get({
    url: "/fly-car/one",
    params: params
  })
}
export function getRelevanceAircraftData() {
  return request.get({
    url: "/fly-car/allflys"
  })
}
export function getSubordinateCompanyOptions() {
  return request.get({
    url: "/fly-car/all_comp"
  })
}


export function editGroundResourcesData(data) {
  return request.post({
    url: "/ground_resource/saveorupdate",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function editGroundResourcesType(data) {
  return request.post({
    url: "/ground_resource_type/saveorupdate",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function editFacilityType(data) {
  return request.post({
    url: "/facility_type/saveorupdate",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function editFacilityData(data) {
  return request.post({
    url: "/facility/saveorupdate",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function editAircraft(data) {
  return request.post({
    url: "/fly-car/saveorupdate",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}

export function deleteGroundResourcesData(params) {
    return request.delete({
      url: "/ground_resource/del",
      params: params
    })
}
export function deleteGroundResourcesType(params) {
    return request.delete({
      url: "/ground_resource_type/del",
      params: params
    })
}
export function deleteFacilityType(params) {
    return request.delete({
      url: "/facility_type/del",
      params: params
    })
}
export function deleteFacilityData(params) {
    return request.delete({
      url: "/facility/del",
      params: params
    })
}
export function deleteAircraft(params) {
    return request.delete({
      url: "/fly-car/del",
      params: params
    })
}
export function getGroundResourcesTypeOptions() {
  return request.get({
    url: "/ground_resource_type/all"
  })
}
export function getFacilityTypeOptions() {
  return request.get({
    url: "/facility_type/all"
  })
}
// 上传图片
export const UploadImg = async (data) => {
    return request.post({
        url: "/file/uploads",
        data: qs.stringify(data),
        headers: {
            'Content-Type': 'multipart/form-data',
            'type':'image/jpeg'
        }
    })
}
